import { render } from "./EditHtml.vue?vue&type=template&id=3645ded8"
import script from "./EditHtml.vue?vue&type=script&lang=js"
export * from "./EditHtml.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__